import React, { useState } from "react";
import { PiExportBold } from "react-icons/pi";
import { ErrorToast } from "../../Utils/SweetAlert";

export const ExportButton = ({ moduleName = "export", fileName, apiService, data, className = "primary-button btn-sm", disabled = false, }) => {
  const [isLoading, setIsLoading] = useState(false);

  const buildBlobFromResponse = (response) => {

    if (!response?.data?.buffer?.data) {
      return false;
    }
    // Convert buffer array to Uint8Array
    const bufferData = new Uint8Array(response?.data?.buffer?.data);

    // Create Blob from buffer
    const blob = new Blob([bufferData], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

    // Create Object URL for downloading
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${moduleName}.xlsx`; // Set file name
    document.body.appendChild(a);
    a.click();

    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  const downloadBlob = (blob) => {
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = `${fileName || moduleName}.xlsx`;
    document.body.appendChild(anchor);
    anchor.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(anchor);
  };

  const handleExport = async () => {
    if (!apiService || isLoading) return;
    setIsLoading(true);
    try {
      const resp = await apiService(data);
      const blob = buildBlobFromResponse(resp);
      if (blob) {
        downloadBlob(blob);
      }
    } catch (error) {
      ErrorToast(error?.response?.data?.message || "Server Error.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      type="button"
      className={className}
      onClick={handleExport}
      disabled={disabled || isLoading}
      aria-busy={isLoading}
      aria-label={isLoading ? "Exporting" : "Export"}
    >
      <span className="d-inline-flex align-items-center">
        <PiExportBold className="me-2" />
        {isLoading ? "Exporting..." : "Export"}
      </span>
    </button>
  );
};